import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { UsersService } from '../../../services/users.service';
import { AddUserDTO } from '../../../interfaces/user.interface';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfigRutService } from 'src/app/services/config-rut.service';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent {
  passBool :boolean;
  constructor(private userService: UsersService,
    public dialogRef: MatDialogRef<AddUserComponent>,
    private configuracionRut: ConfigRutService,


  ) {}
  public form = new FormGroup({
    rut: new FormControl<string | ''>('', [Validators.required]),
    firstName: new FormControl<string | ''>(''),
    lastName: new FormControl<string | ''>('', [Validators.required]),
    email: new FormControl<string | ''>(''),
    phone: new FormControl<number | 0>(0, [Validators.required]),
    password: new FormControl<string | ''>(''),
  });

  submit() {
    const request: AddUserDTO = {
      rut: this.form.value.rut,
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName,
      email: this.form.value.email,
      phone: this.form.value.phone,
      password: this.form.value.password,
    };
    Swal.fire({
      title: 'Registrando Usuario',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
        this.userService.postUsers(request).subscribe({
          next: (e) => {
            console.log(e);
            Swal.fire({
              title: 'Registro Realizado',
              icon: 'success',
            }).then((result) => {
              if (result.isConfirmed) {
                this.passBool = true;
                this.dialogRef.close(this.passBool);
              }
            });
          },
          error: (error) => {
            console.log(error);
            Swal.fire({
              title: error.error.message,
              text: 'No fue posible añadir al usuario',
              icon: 'error',
              showConfirmButton: true,
              confirmButtonText: 'Cerrar',
            });
          },
        });
      },
    });
  }

  inputRut(event) {
    const { formattedRut, validation } = this.configuracionRut.changeRut(event);
    this.form.controls['rut'].setValue(formattedRut);
    if (!validation) {
      this.form.controls['rut'].setErrors({
        invalidRut: false,
      });
    }
    console.log(event);
    this.configuracionRut.transformStringRut(event.target.value);
  
  }
  cerrarDialogo() {
    this.dialogRef.close();
  }


}
